/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  BoardEarnObjectivesResponse,
  GetLedgerStandingsResponse,
  GetMyLedgerContributionsResponse,
  LedgerBoardPrizeLadderResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    BoardEarnObjectivesResponseFromJSON,
    BoardEarnObjectivesResponseToJSON,
    GetLedgerStandingsResponseFromJSON,
    GetLedgerStandingsResponseToJSON,
    GetMyLedgerContributionsResponseFromJSON,
    GetMyLedgerContributionsResponseToJSON,
    LedgerBoardPrizeLadderResponseFromJSON,
    LedgerBoardPrizeLadderResponseToJSON,
} from '../models/index';

export interface GetLedgerBoardsBoardIdEarnObjectivesRequest {
    boardId: string;
}

export interface GetLedgerBoardsBoardIdMyContributionsRequest {
    boardId: string;
    periodKey?: string;
}

export interface GetLedgerBoardsBoardIdPrizesRequest {
    boardId: string;
}

export interface GetLedgerBoardsBoardIdStandingsRequest {
    boardId: string;
    periodKey?: string;
    limit?: string;
    offset?: string;
}

/**
 * LedgerBoardsApi - interface
 * 
 * @export
 * @interface LedgerBoardsApiInterface
 */
export interface LedgerBoardsApiInterface {
    /**
     * The objectives assigned to this board, as its earn section renders them, with a signed-in member\'s used-up claim cards flagged. Public for a running or ended board; a board that is switched off, not yet started, or owned by an admin-only challenge 404s.
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerBoardsApiInterface
     */
    getLedgerBoardsBoardIdEarnObjectivesRaw(requestParameters: GetLedgerBoardsBoardIdEarnObjectivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BoardEarnObjectivesResponse>>;

    /**
     * The objectives assigned to this board, as its earn section renders them, with a signed-in member\'s used-up claim cards flagged. Public for a running or ended board; a board that is switched off, not yet started, or owned by an admin-only challenge 404s.
     */
    getLedgerBoardsBoardIdEarnObjectives(requestParameters: GetLedgerBoardsBoardIdEarnObjectivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BoardEarnObjectivesResponse>;

    /**
     * The authenticated caller\'s own contributions on a board for the resolved period, grouped by the granting engagement — the MY POINTS breakdown.
     * @param {string} boardId 
     * @param {string} [periodKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerBoardsApiInterface
     */
    getLedgerBoardsBoardIdMyContributionsRaw(requestParameters: GetLedgerBoardsBoardIdMyContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyLedgerContributionsResponse>>;

    /**
     * The authenticated caller\'s own contributions on a board for the resolved period, grouped by the granting engagement — the MY POINTS breakdown.
     */
    getLedgerBoardsBoardIdMyContributions(requestParameters: GetLedgerBoardsBoardIdMyContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyLedgerContributionsResponse>;

    /**
     * Which ranks pay and what each place receives. `payingPlaces` is the deepest paying rank, so a surface can say \"Top N win prizes\" without anyone authoring N by hand and it going stale when the tiers change. A board with no rank tiers answers zero places and an empty list.
     * @summary The board\'s prize ladder, with names and artwork
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerBoardsApiInterface
     */
    getLedgerBoardsBoardIdPrizesRaw(requestParameters: GetLedgerBoardsBoardIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LedgerBoardPrizeLadderResponse>>;

    /**
     * Which ranks pay and what each place receives. `payingPlaces` is the deepest paying rank, so a surface can say \"Top N win prizes\" without anyone authoring N by hand and it going stale when the tiers change. A board with no rank tiers answers zero places and an empty list.
     * The board\'s prize ladder, with names and artwork
     */
    getLedgerBoardsBoardIdPrizes(requestParameters: GetLedgerBoardsBoardIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LedgerBoardPrizeLadderResponse>;

    /**
     * Paginated standings for a board — the current period by default, or an explicit periodKey (empty string = all-time).
     * @param {string} boardId 
     * @param {string} [periodKey] 
     * @param {string} [limit] 
     * @param {string} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerBoardsApiInterface
     */
    getLedgerBoardsBoardIdStandingsRaw(requestParameters: GetLedgerBoardsBoardIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLedgerStandingsResponse>>;

    /**
     * Paginated standings for a board — the current period by default, or an explicit periodKey (empty string = all-time).
     */
    getLedgerBoardsBoardIdStandings(requestParameters: GetLedgerBoardsBoardIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLedgerStandingsResponse>;

}

/**
 * 
 */
export class LedgerBoardsApi extends runtime.BaseAPI implements LedgerBoardsApiInterface {

    /**
     * The objectives assigned to this board, as its earn section renders them, with a signed-in member\'s used-up claim cards flagged. Public for a running or ended board; a board that is switched off, not yet started, or owned by an admin-only challenge 404s.
     */
    async getLedgerBoardsBoardIdEarnObjectivesRaw(requestParameters: GetLedgerBoardsBoardIdEarnObjectivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BoardEarnObjectivesResponse>> {
        if (requestParameters['boardId'] == null) {
            throw new runtime.RequiredError(
                'boardId',
                'Required parameter "boardId" was null or undefined when calling getLedgerBoardsBoardIdEarnObjectives().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ledger-boards/{boardId}/earn-objectives`;
        urlPath = urlPath.replace(`{${"boardId"}}`, encodeURIComponent(String(requestParameters['boardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BoardEarnObjectivesResponseFromJSON(jsonValue));
    }

    /**
     * The objectives assigned to this board, as its earn section renders them, with a signed-in member\'s used-up claim cards flagged. Public for a running or ended board; a board that is switched off, not yet started, or owned by an admin-only challenge 404s.
     */
    async getLedgerBoardsBoardIdEarnObjectives(requestParameters: GetLedgerBoardsBoardIdEarnObjectivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BoardEarnObjectivesResponse> {
        const response = await this.getLedgerBoardsBoardIdEarnObjectivesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The authenticated caller\'s own contributions on a board for the resolved period, grouped by the granting engagement — the MY POINTS breakdown.
     */
    async getLedgerBoardsBoardIdMyContributionsRaw(requestParameters: GetLedgerBoardsBoardIdMyContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyLedgerContributionsResponse>> {
        if (requestParameters['boardId'] == null) {
            throw new runtime.RequiredError(
                'boardId',
                'Required parameter "boardId" was null or undefined when calling getLedgerBoardsBoardIdMyContributions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['periodKey'] != null) {
            queryParameters['periodKey'] = requestParameters['periodKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ledger-boards/{boardId}/my-contributions`;
        urlPath = urlPath.replace(`{${"boardId"}}`, encodeURIComponent(String(requestParameters['boardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyLedgerContributionsResponseFromJSON(jsonValue));
    }

    /**
     * The authenticated caller\'s own contributions on a board for the resolved period, grouped by the granting engagement — the MY POINTS breakdown.
     */
    async getLedgerBoardsBoardIdMyContributions(requestParameters: GetLedgerBoardsBoardIdMyContributionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyLedgerContributionsResponse> {
        const response = await this.getLedgerBoardsBoardIdMyContributionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Which ranks pay and what each place receives. `payingPlaces` is the deepest paying rank, so a surface can say \"Top N win prizes\" without anyone authoring N by hand and it going stale when the tiers change. A board with no rank tiers answers zero places and an empty list.
     * The board\'s prize ladder, with names and artwork
     */
    async getLedgerBoardsBoardIdPrizesRaw(requestParameters: GetLedgerBoardsBoardIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LedgerBoardPrizeLadderResponse>> {
        if (requestParameters['boardId'] == null) {
            throw new runtime.RequiredError(
                'boardId',
                'Required parameter "boardId" was null or undefined when calling getLedgerBoardsBoardIdPrizes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ledger-boards/{boardId}/prizes`;
        urlPath = urlPath.replace(`{${"boardId"}}`, encodeURIComponent(String(requestParameters['boardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LedgerBoardPrizeLadderResponseFromJSON(jsonValue));
    }

    /**
     * Which ranks pay and what each place receives. `payingPlaces` is the deepest paying rank, so a surface can say \"Top N win prizes\" without anyone authoring N by hand and it going stale when the tiers change. A board with no rank tiers answers zero places and an empty list.
     * The board\'s prize ladder, with names and artwork
     */
    async getLedgerBoardsBoardIdPrizes(requestParameters: GetLedgerBoardsBoardIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LedgerBoardPrizeLadderResponse> {
        const response = await this.getLedgerBoardsBoardIdPrizesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Paginated standings for a board — the current period by default, or an explicit periodKey (empty string = all-time).
     */
    async getLedgerBoardsBoardIdStandingsRaw(requestParameters: GetLedgerBoardsBoardIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLedgerStandingsResponse>> {
        if (requestParameters['boardId'] == null) {
            throw new runtime.RequiredError(
                'boardId',
                'Required parameter "boardId" was null or undefined when calling getLedgerBoardsBoardIdStandings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['periodKey'] != null) {
            queryParameters['periodKey'] = requestParameters['periodKey'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ledger-boards/{boardId}/standings`;
        urlPath = urlPath.replace(`{${"boardId"}}`, encodeURIComponent(String(requestParameters['boardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLedgerStandingsResponseFromJSON(jsonValue));
    }

    /**
     * Paginated standings for a board — the current period by default, or an explicit periodKey (empty string = all-time).
     */
    async getLedgerBoardsBoardIdStandings(requestParameters: GetLedgerBoardsBoardIdStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLedgerStandingsResponse> {
        const response = await this.getLedgerBoardsBoardIdStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
